<div class="row">
  <!--  date picker -->
  <div [class]="config?.responsiveClassName || 'md:!tw-w-1/2 sm:!tw-pl-3 sm:ltr:!tw-pr-3 !px-0'">
    <datepicker
      [isEdit]="config?.isEditMode"
      [isDisabled]="disabled"
      [label]="config?.dateLabel"
      [control]="config?.dateFormControl"
      [min]="config?.minDate"
      [max]="config?.maxDate"
      [minType]="config?.isEditMode ? 'unlimited' : config?.minDateType"
      [maxType]="config?.isEditMode ? 'unlimited' : config?.maxDateType"
      [value]="date"
      [isAdvancedSearch]="config?.isAdvancedSearch"
      (value)="date = $event; combineDateAndTime()"
      (onErrorDatePicker)="showErrorDialog($event)"
    >
    </datepicker>
  </div>

  <!--  time picker -->
  <div [class]="config?.responsiveClassName || 'md:!tw-w-1/2 sm:!tw-pr-3 sm:!ltr:tw-pl-3 !px-0'">
    <timepicker
      [control]="config?.timeFormControl"
      [isDisabled]="disabled"
      [label]="config?.timeLabel"
      [value]="time"
      (value)="time = $event; combineDateAndTime()"
      [minType]="config?.minTimeType"
      [maxType]="config?.maxTimeType"
      [minTime]="config?.minTime"
      [maxTime]="config?.maxTime"
      [confirmBtnClass]="'btn' | themeColor"
    >
    </timepicker>
  </div>
</div>
